export const GGList = {
    "systime": "/Date(1642520248136)/",
    "data": [

        {
            "Title": "",
            "LinkURL": "#",
            "Position": "PB",
            "ID": "98",
            "RegionID": 0,
            "ResourceType": 0,
            "UpdateTime": "/Date(1642498903660)/",
            "DefaultID": 623,
            "DesignID": 0,
            "PIDuration": 0,
            "RawImage": "/assets/images/PB.jpg",
            "ApplySite": 1,
        },
        {
            "Title": "",
            "LinkURL": "#",
            "Position": "PR1",
            "ID": "96",
            "RegionID": 0,
            "ResourceType": 0,
            "UpdateTime": "/Date(1642335502557)/",
            "DefaultID": 622,
            "DesignID": 0,
            "PIDuration": 0,
            "RawImage": "/assets/images/PR.jpg",
            "ApplySite": 1,
            "AppParam": ""
        },
        {
            "Title": "",
            "LinkURL": "#",
            "Position": "SS",
            "ID": "305",
            "RegionID": 0,
            "ResourceType": 0,
            "UpdateTime": "/Date(1641907303740)/",
            "DefaultID": 624,
            "DesignID": 0,
            "PIDuration": 0,
            "RawImage": "/assets/images/SS.jpg",
            "ApplySite": -1,
            "AppParam": ""
        },
        {
            "Title": "",
            "LinkURL": "#",
            "Position": "DL",
            "ID": "306",
            "RegionID": 0,
            "ResourceType": 0,
            "UpdateTime": "/Date(1642151891803)/",
            "DefaultID": 625,
            "DesignID": 0,
            "PIDuration": 0,
            "RawImage": "/assets/images/DL.jpg",
            "ApplySite": -1,
            "AppParam": ""
        }
    ],
    "country": "GL"
}